import styled from 'styled-components';
import { Typography } from '../../../global/theme';
import { AlignCenter } from '../../../global/commonStyle';

const Main = styled.form``;

const Bottom = styled.div`
  padding: var(--space-16);
  display: flex;
  flex-direction: column;
  gap: var(--space-24);
`;

const FormButton = styled.div`
  display: flex;
  gap: var(--space-12);
  justify-content: space-between;
`;
const Form = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-16);
`;

const Icon = styled.div`
  height: 16px;
  .fill-colors {
    fill: var(--text-secondary);
  }
  .fill-stroke {
    stroke: var(--text-secondary);
  }
`;
const DropTab = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
  padding: var(--space-6) var(--space-8);
  border-radius: var(--border-radius-6);
  box-shadow: var(--border);
  cursor: pointer;
  .fill-color {
    fill: var(--text-secondary);
  }
  .fill-stroke {
    stroke: var(--text-secondary);
  }
  &:hover {
    background-color: var(--neutral-secondary);
  }
`;
const Titles = styled.div`
  color: var(--text-secondary);
  ${Typography.body_md_medium}
`;

const Description = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  h2 {
    margin: var(--space-0);
    ${Typography.body_md}
    color: var(--text-primary);
  }
  p {
    ${Typography.body_sm}
    color: var(--text-secondary);
    margin: var(--space-0);
  }
`;
export { Main, Bottom, FormButton, Form, Icon, DropTab, Titles, Description };
